import { render, staticRenderFns } from "./DetailEngineer.vue?vue&type=template&id=1350d637&"
import script from "./DetailEngineer.vue?vue&type=script&lang=js&"
export * from "./DetailEngineer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports